import { render, staticRenderFns } from "./ViewerSearch.vue?vue&type=template&id=4b6b4fe8&scoped=true"
import script from "./ViewerSearch.vue?vue&type=script&lang=js"
export * from "./ViewerSearch.vue?vue&type=script&lang=js"
import style0 from "./ViewerSearch.vue?vue&type=style&index=0&id=4b6b4fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b4fe8",
  null
  
)

export default component.exports